module.exports = __webpack_public_path__ + "static/img/banner-bienvenidos-1024x768.7c0b300.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banners/banner-bienvenidos-1024x768.jpg
// module id = hho5
// module chunks = 47